/* eslint-disable @typescript-eslint/no-empty-function */
import { useState } from "react";

import * as MUI from "@mui/material";
import * as Icon from "@mui/icons-material";
import { toast } from "react-toastify";
import { RiLockPasswordFill } from "react-icons/ri";
import apiUsuario from "../../services/apiUsuario";
import { useAuth } from "../../hooks/auth";

interface Props {
  CPF: string;
}

export const FormDialog = () => {
  const [open, setOpen] = useState(true);
  const [newPassword, setnewPassword] = useState("");
  const storedToken = sessionStorage.getItem("@webSDS:token");
  const { logout } = useAuth();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = async () => {
    const response = await apiUsuario.put(
      "user/updateAccess",
      {
        novaSenha: newPassword,
      },
      {
        headers: {
          Authorization: `Bearer ${storedToken}`,
        },
      }
    );

    if (response.status === 200) {
      toast.success(`${response.data}`, {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 1500,
      });

      setTimeout(() => {
        setOpen(false);
        logout();
      }, 1500);
    }
    if (response.status === 500 || response.status === 503) {
      toast.success("Erro no servidor, tente mais tarde!", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });

      setTimeout(() => {
        setOpen(false);
        logout();
      }, 1500);
    }
    if (response.status === 504) {
      toast.error(
        "O Servidor demorou muito pra responder, tente novamente em instantes.",
        {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000,
        }
      );

      setTimeout(() => {
        setOpen(false);
        logout();
      }, 1500);
    }
  };

  return (
    <div>
      <MUI.Button variant="outlined" color="primary" onClick={handleClickOpen}>
        Modificar Senha
      </MUI.Button>
      <MUI.Dialog
        open={open}
        onClose={() => setOpen(true)}
        aria-labelledby="form-dialog-title"
      >
        <MUI.DialogTitle id="form-dialog-title">
          <MUI.Typography variant="body1">Modificar Senha</MUI.Typography>
        </MUI.DialogTitle>
        <MUI.DialogContent>
          <MUI.DialogContentText>
            <MUI.Typography variant="body2">
              Seja bem vindo ao Polícia Ágil, sua senha encontra-se como
              aleatória de acordo como foi criado seu usuário. Ao atualizar a
              senha o sistema irá fazer logout, favor fazer login com a senha
              criada!
            </MUI.Typography>
          </MUI.DialogContentText>
          <MUI.TextField
            value={newPassword}
            onChange={(e) => setnewPassword(e.target.value)}
            autoFocus
            margin="dense"
            id="name"
            label="Digite aqui"
            fullWidth
          />
        </MUI.DialogContent>
        <MUI.DialogActions>
          <MUI.Button onClick={handleClose} color="primary">
            Atualizar
          </MUI.Button>
        </MUI.DialogActions>
      </MUI.Dialog>
    </div>
  );
};

export const DialogPassword = ({ CPF }: Props) => {
  const [open, setOpen] = useState(false);
  const storedToken = sessionStorage.getItem("@webSDS:token");

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleReset = async () => {
    const response = await apiUsuario.put(
      "resetPassword",
      {
        CPF,
      },
      {
        headers: {
          Authorization: `Bearer ${storedToken}`,
        },
      }
    );
    if (response.status === 200) {
      toast.success(`${response.data}`, {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2500,
      });
    }
    if (response.status === 500 || response.status === 503) {
      toast.success("Erro no servidor, tente mais tarde!", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
    }
    if (response.status === 504) {
      toast.success("Erro no servidor, tente mais tarde!", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
    }
    setOpen(false);
  };

  return (
    <>
      <abbr title="Reset de senha apenas usuário externo">
        <MUI.IconButton onClick={handleClickOpen}>
          <RiLockPasswordFill style={{ color: "#c23636" }} />
        </MUI.IconButton>
      </abbr>
      <MUI.Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <MUI.DialogTitle id="alert-dialog-title">
          <MUI.Typography variant="body1">
            Deseja realmente resetar a senha?
          </MUI.Typography>
        </MUI.DialogTitle>
        <MUI.DialogContent>
          <MUI.DialogContentText id="alert-dialog-description">
            <MUI.Typography variant="body2">
              Ao resetar a senha do usuário, será enviado uma nova senha
              aleatória ao email cadastrado do usuário.
            </MUI.Typography>
          </MUI.DialogContentText>
        </MUI.DialogContent>
        <MUI.DialogActions>
          <MUI.Button onClick={handleClose} color="primary">
            Cancelar
          </MUI.Button>
          <MUI.Button
            variant="contained"
            onClick={handleReset}
            color="primary"
            autoFocus
          >
            Resetar
          </MUI.Button>
        </MUI.DialogActions>
      </MUI.Dialog>
    </>
  );
};

export const DialogResetOTP = ({ CPF }: Props) => {
  const [open, setOpen] = useState(false);
  const storedToken = sessionStorage.getItem("@webSDS:token");

  const handleClickOpen = () => {
    console.log("ABriu o popup");
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleResetOtp = async () => {
    const response = await apiUsuario.put(
      "resetOTP",
      {
        CPF,
      },
      {
        headers: {
          Authorization: `Bearer ${storedToken}`,
        },
      }
    );
    if (response.status === 200) {
      toast.success(`${response.data}`, {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2500,
      });
    }
    if (response.status === 500 || response.status === 503) {
      toast.success("Erro no servidor, tente mais tarde!", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
    }
    if (response.status === 504) {
      toast.success("Erro no servidor, tente mais tarde!", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
    }
    setOpen(false);
  };
  return (
    <>
      <abbr title="Reset de OTP">
        <MUI.IconButton onClick={handleClickOpen}>
          <Icon.PhonelinkLock style={{ color: "#7C0A02" }} />
        </MUI.IconButton>
      </abbr>
      <MUI.Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <MUI.DialogTitle id="alert-dialog-title">
          <MUI.Typography variant="body1">
            Deseja realmente resetar o OTP?
          </MUI.Typography>
        </MUI.DialogTitle>
        <MUI.DialogContent>
          <MUI.DialogContentText id="alert-dialog-description">
            <MUI.Typography variant="body2">
              Ao resetar o OTP do usuário, o mesmo deverá cadastrar um novo
              código.
            </MUI.Typography>
          </MUI.DialogContentText>
        </MUI.DialogContent>
        <MUI.DialogActions>
          <MUI.Button onClick={handleClose} color="primary">
            Cancelar
          </MUI.Button>
          <MUI.Button
            variant="contained"
            onClick={handleResetOtp}
            color="primary"
            autoFocus
          >
            Resetar
          </MUI.Button>
        </MUI.DialogActions>
      </MUI.Dialog>
    </>
  );
};
